import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useStyles } from './styles';
import {
  Box, Grid, Typography, Button, CircularProgress, FormControl, InputLabel,
   TextField, OutlinedInput, InputAdornment, IconButton, Checkbox, FormControlLabel, FormGroup, TextareaAutosize
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import Visibility from '@material-ui/icons/Visibility';
import InfoIcon from '@material-ui/icons/Info';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { checkDigitOnly, scrollTop, renderDefaultMsg, getAppSource, getUserType, getLoanLabel, getBorrowerLabel, getPublicIp, maskEmail, isAdminCheck, getAccountLabel, maskAccountNo, maskMailingAddress } from '../../helpers'
import Cookies from 'js-cookie';
import CustomBreadcrum from '../Breadcrum';
import { verifyLoanInformation, ccpaDeletion, getMyProfile, getPrivacySecurityContent } from '../../actions';
import { useHistory } from 'react-router-dom';
import { decrypt, encrypt } from '../../helpers/encrypt';
import { RequestSubmitPopup } from '../SupportTicket/RequestSubmitPopup';
import { DocumentRequestPopup } from '../SupportTicket/DocumentRequestPopup';
import { SubmitConfirmation } from './SubmitConfirmation';
import './index.css';

export const CcpaDeletion = React.memo(() => {

  const mytheme = useSelector(state => state.theme);
  const { primaryColorCode, secondaryColorCode, privateLabelName } = mytheme;
  const props = { primaryColorCode: primaryColorCode, secondaryColorCode: secondaryColorCode };
  const classes = useStyles(props);
  const history = useHistory();
  
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [captchaCode, setCaptchaCode] = useState('');
  const [captchaErr, setcaptchaErr] = useState(false);
  const [volumeIcon, setvolumeIcon] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [errors, setErrors] = useState({mandatoryOptions: false, decsMandatory: false});
  const [touched, setTouched] = useState({});
  const [state, setState] = useState({
    loanNo: '', lastName: '', state: '', zip: '', email: '', request: '', captcha: '', ssn: '', showssn: false
  });

  const [errorMessage, setErrorMessage] = useState('')
  const captchaTimer = useRef(null);
  const [options, setOptions] = useState({
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
    option3Desc: ''
  });
  const [toogleStatus, setToogleStatus] = useState(false);
  const [borrowerInfo, setBorrowerInfo] = useState({accountNumber: '', pBorrowerName: '', emailID: '', malingAddress: ''});
  const [displayForm, setDisplayForm] = useState(Cookies.get('privateToken') ? false : true);
  const [submitPopup, setSubmitPopup] = useState(false);
  const [restrictionPopup, displayRestrictionPopup] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [data, setData] = useState('');
  const [submitStatus, setSubmitConfirmation] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    if (Cookies.get('privateToken')) {
      getUserDetail();
      if (Cookies.get("isCAState") == 'false') {
        displayRestrictionPopup(true)
      }
    }
  }, []);
 
  const getUserDetail = async () => {
    const requestData = {
      "accountNumber": Cookies.get("selectedAccount"),
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    }
    const result = await getMyProfile(requestData)
    scrollTop();
    if (result) {
      const { lstResponseStatus } = result
      if (result && (lstResponseStatus[0].statusCode == 0)) {
        setBorrowerInfo({accountNumber: encrypt(result.accountNumber), pBorrowerName: `${result.firstName}  ${result.lastName}`, emailID: result.emailID, malingAddress: `${result.address1 ? encrypt(result.address1) : ''}  ${result.address2 ? encrypt(result.address2) : ''}`});
      } else {
        setErrorMessage(lstResponseStatus[0].statusDesc)
      }
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }
 
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res = await dispatch(getPrivacySecurityContent('PC036'));
    if (res && res.lstPageContentDetails) {
      setData(res.lstPageContentDetails[0].contentValue.replaceAll('[privateLabelName]', mytheme.privateLabelName).replaceAll('[customerCareNumber]', mytheme.customerCareNumber).replaceAll('[address]', mytheme.address));
    } else {
      setData('');
    }
  }

  useEffect(() => {
      createCaptcha()
      handleTimer();
      return () => clearInterval(captchaTimer.current);
    }, [displayForm]);
  
    const handleTimer = () => {
      captchaTimer.current = setInterval(() => {
        createCaptcha()
      }, 180000);
      return () => clearInterval(captchaTimer.current);
    }
  
    const handleReset = () => {
      clearInterval(captchaTimer.current);
    }
  
    const createCaptcha = () => {
      setcaptchaErr(false)
      if (document.getElementById('captcha') !== null) {
        const cpatchCode = returnMathsCaptchaCode();
        setCaptchaCode(cpatchCode)
      }
    }
  
    const returnMathsCaptchaCode = () => {
      var code;
      document.getElementById('captcha').innerHTML = "";
     
      var captcha = [];
      var canv = document.createElement("canvas");
    
      var fir = Math.floor(Math.random() * 10)
      var third = Math.floor(Math.random() * 10)
      captcha[0] = fir;
      captcha[1] = '+';
      captcha[2] = third;
      captcha[3] = '=';
  
      canv.id = "captcha";
      canv.width = 170;
      canv.height = 40;
      canv.padding = 10;
      var ctx = canv.getContext("2d");
      ctx.font = "600 36px 'Montserrat'";
      ctx.fillText(captcha.join(""), 0, 30);
      code = captcha.join("");
      document.getElementById("captcha").appendChild(canv);
      return code;
    }
  
  const check = () => {
    setvolumeIcon(true)
    setTimeout(function () { setvolumeIcon(false) }, 2500);
  }

  const speakk = () => {
    let speech = new SpeechSynthesisUtterance();
    speech.lang = "en-UK";
    speech.text = captchaCode;
    speech.volume = 2;
    speech.rate = 0.25;
    speech.pitch = 1.4;

    window.speechSynthesis.speak(speech);
  }

  const handleFormTextChange = (prop) => (event) => {
    if (prop === 'loanNo') {
      if (checkDigitOnly(event.target.value)) {
       if ((/^[0-9]+$/).test(event.target.value) || event.target.value === '') {
        setState({ ...state, [event.target.name]: event.target.value.slice(0, 10) });
       }
      }
      return;
    } else if (prop === 'ssn') {
      if (!(/[^\w\s]/gi).test(event.target.value) && !(/\s/g).test(event.target.value)) {
        setState({ ...state, [event.target.name]: event.target.value.slice(0, 4) });
      }
      return;
    } else if (prop === "zip") {
      if (checkDigitOnly(event.target.value)) {
        if (event.target.value.length <= 5) {
          setTouched({
            ...touched,
            [event.target.name]: true
          });
          setState({
            ...state,
            [event.target.name]: event.target.value
          })
        }
      }
      return;
    }
  
    setState({
      ...state,
      [event.target.name]: event.target.value
    })
    return;
  }

  const handleFormSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setErrorMsg('');

    if ((Number(captchaCode[0]) + Number(captchaCode[2])) == Number(state.captcha)) {
      setcaptchaErr(false);
      const data = {
        "accountNumber": encrypt(state.loanNo),
        "borrowerSSN": encrypt(state.ssn),
        "propertyZipCode": state.zip,
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": await getPublicIp(),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": ""
      };

      const result = await verifyLoanInformation(data);
      setLoading(false);
      if (result && (result?.lstResponseStatus[0]?.statusCode == 0)) {
         setState({
          loanNo: '', lastName: '', state: '', zip: '', email: '', request: '', identity: '', ssn: '', showssn: false, captcha: ''
        });
        if (result?.lstResponseStatus[0]?.statusDesc.includes('invalid')) {
          setErrorMsg(result?.lstResponseStatus[0]?.statusDesc)
        } else if (result?.lstResponseStatus[0]?.statusDesc.includes('CA')) {
          displayRestrictionPopup(true)
        } else {
          setBorrowerInfo(result)
          setDisplayForm(false)
        }
      } else {
        setErrorMsg(result?.lstResponseStatus[0]?.statusDesc)
      }
    } else {
      setLoading(false);
      setState({ ...state, captcha: '' });
      createCaptcha();
      handleReset();
      handleTimer();
      setcaptchaErr(true);
    }
  }

  const handleSubmitConfirmation = async () => {
    setSubmitConfirmation(false)
    setErrorMsg('');
    setSubmitLoader(true)
    const data = {
      "accountNumber": borrowerInfo.accountNumber,
      "pBorrowerName": borrowerInfo.pBorrowerName,
      "emailID": borrowerInfo.emailID,
      "deletionRequest": buildSelectedOptionsHTML(options, options.option3Desc),
      "emailType": 'CCPADeleteConfirmationToBorrower',
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": await getPublicIp(),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const result = await ccpaDeletion(data);
    if (result && (result?.lstResponseStatus[0]?.statusCode == 0)) {
      setSubmitLoader(false)
      setSubmitPopup(true)
    } else {
      setErrorMsg(result?.lstResponseStatus[0]?.statusDesc)
      setSubmitLoader(false)
    }
  }

   const handleRequestSubmit = async () => {
     if (!options.option1 && !options.option2 && !options.option3 && !options.option4 && !options.option5) {
       setErrors({ ...errors, mandatoryOptions: true});
     } else if(options.option3 && !options.option3Desc) { 
       setErrors({ ...errors, decsMandatory: true});
     } else {
       setSubmitConfirmation(true)
    }
  }

  const buildSelectedOptionsHTML = (options, documentDesc) => {

    const OPTION_CONTENT = {
    option1: {
      title: 'Option 1',
      text: 'I request to opt out of the sale or sharing of my personal information, including for cross-context behavioral advertising, as permitted under the California Consumer Privacy Act (CCPA). I understand that certain personal information collected in connection with financial products or services may be exempt under federal law.'
    },
    option2: {
      title: 'Option 2',
      text:
        `I request that ${privateLabelName} delete my personal information, to the extent permitted by law, where such information is no longer necessary for  ${privateLabelName} business relationship with me or for legal and regulatory compliance.`
    },
    option3: {
      title: 'Option 3',
      text:
        `I request that ${privateLabelName} correct inaccurate personal information related to my account, as described below:`
    },
    option4: {
      title: 'Option 4',
      text:
        `I request to know what personal information ${privateLabelName} has collected about me, including the categories of information, the purposes for collection, and the categories of third parties with whom it has been disclosed, as permitted by law.`
    },
    option5: {
      title: 'Option 5',
      text:
        `I request that ${privateLabelName} limit the use and disclosure of my sensitive personal information to purposes permitted by applicable law.`
    }
  };

  return Object.keys(OPTION_CONTENT)
    .filter((key) => options[key])
    .map((key) => {
      const { title, text } = OPTION_CONTENT[key];
 
      if (key === 'option3' && documentDesc) {
        return `<b>${title}</b><br/>${text}</br><i>${documentDesc}</i>`;
      }
 
      return `<b>${title}</b><br/>${text}`;
    }).join('<br/><br/>')
  }  
  
  const handleClickShowPassword = () => {
    setState({ ...state, showssn: !state.showssn });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const checkboxChangePostDataHandler = (event) => {
    setOptions({
      ...options,
      [event.target.name]: event.target.checked
    })
    setErrors({ ...errors, mandatoryOptions: false});
  }
 
  const handleDesc = (event) => {
    setOptions({
      ...options,
      [event.target.name]: event.target.value.replace(/^\s+/, '')
    })
    setErrors({ ...errors, decsMandatory: false});
  }

  const calculateCommentLenth = () => {
    const length = options.option3Desc?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const handleCancel = () => {
    if (Cookies.get('privateToken') && (history?.length > 1)) {
      history.goBack();
    } else if (Cookies.get('privateToken') && (history?.length == 1)) {
      history.push('/Privacy')
    } else if (history?.length == 1) {
      history.push('/Privacy')
    } else if (history?.length > 1) {
      history.goBack();
      // setErrorMsg('')
      // setDisplayForm(true)
    }
  }

  const handleGoBack = () => {
    if (history?.length == 1) {
      history.push('/Privacy')
    } else {
      history.goBack()
    }
  }

  const handleSubmitPopup = () => {
    setSubmitPopup(false);
    if (history?.length > 1) {
      history.goBack();
    } else if (history?.length == 1) {
      history.push('/Privacy')
    }
  }

  const handleGotIt = () => {
    if (Cookies.get('privateToken') && (Cookies.get("isCAState") == 'false')) {
      displayRestrictionPopup(false)
       if (history?.length > 1) {
        history.goBack();
      } else if (history?.length == 1) {
        history.push('/Privacy')
      }
    } else {
      displayRestrictionPopup(false)
    }
  }
  
  if (loader) {
    return (
      <Box className={classes.loaderRoot}>
        <CircularProgress />
      </Box>
    )
  }

  const disableBtn = state.loanNo.length === 0 || state.ssn.length === 0 || state.zip.length === 0 
    || state.captcha.length === 0 

  return (
    <Box className={classes.mainRoot}>
      <Box className={classes.root} >
        <CustomBreadcrum backPage="Home" backPageLink="/" activePage="California Privacy Act Notice" />
        <Box className={classes.topContainer} mx={0}>
          <Typography className={classes.pageHeading} color="textPrimary" component='h4'>California Privacy Act Notice</Typography>
        </Box>

        <Box className={classes.mainContainer}>
          <Box my={1} mx={2} className={classes.formContainer}>
            {displayForm ?
              <form className={classes.formRoot} noValidate autoComplete="off" onSubmit={handleFormSubmit}>
                <h3 className={classes.subTitle}>Verify Your {getAccountLabel()}</h3>
                <p className={`${classes.bobyText} ${classes.topFormText}`}>
                  Please enter all of the information below.
                </p>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6} md={6}>
                    <div>
                      <TextField
                        id="outlined-loan-input"
                        label={`${getLoanLabel()} Number`}
                        color="primary"
                        type="text"
                        value={state.loanNo}
                        name="loanNo"
                        variant="outlined"
                        fullWidth
                        onChange={handleFormTextChange('loanNo')}
                        InputLabelProps={{
                          classes: { root: classes.textField }
                        }}
                        InputProps={{
                          classes: { root: classes.textField, input: classes.textInput },
                          maxLength: 10,
                        }}
                      />
                    </div>
                  </Grid>
                 
                  <Grid item xs={12} sm={6} md={6}>
                    <div>
                      <TextField
                        id="outlined-zip-input"
                        label='Property Zip Code'
                        color="primary"
                        name="zip"
                        type="text"
                        value={state.zip}
                        variant="outlined"
                        fullWidth
                        onChange={handleFormTextChange('zip')}
                        InputLabelProps={{
                          classes: { root: classes.textField }
                        }}
                        InputProps={{
                          classes: { root: classes.textField, input: classes.textInput },
                          maxLength: 5
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6} md={6}>
                     <FormControl variant="outlined" fullWidth>
                        <InputLabel className={classes.labelStyle} htmlFor="outlined-adornment-ssn">Primary {getBorrowerLabel()} SSN/EIN Last 4 Digits</InputLabel>
                        <OutlinedInput
                          color="primary"
                          name="ssn"
                          id="outlined-adornment-ssn"
                          type={state.showssn ? 'text' : 'password'}
                          value={state.ssn}
                          onChange={handleFormTextChange('ssn')}
                          labelWidth={250}
                          inputProps={{
                            className: classes.inputStyle,
                            maxLength: 4
                            
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {state.showssn ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                       
                        />
                      </FormControl>
                  </Grid>
                 
                  <Grid item xs={12} sm={6} md={6}>
                   
                     <Box>
                      <div>
                        <Grid container row spacing={2}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container>
                              <Grid item xs={10} sm={10} md={10}>
                                <div className={classes.captchaarea}>
                                  <div id="captcha" style={{margin: '0px 56px', paddingTop: '8px'}}>
                                  </div>
                                </div>
                              </Grid>
                              <Grid item xs={2} sm={2} md={2} className={classes.buttonarea}>
                                {volumeIcon ? <VolumeOffIcon className={classes.volumeButton} /> : <VolumeUpIcon className={classes.volumeButton} onClick={() => { speakk({ text: captchaCode }); check() }} />}<br />
                                <RefreshIcon className={classes.refreshButton} onClick={() => { createCaptcha() }} />
                              </Grid>
                            </Grid>
        
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <TextField
                              id="outlined-loan-input"
                              label="Answer"
                              color="primary"
                              autoComplete="off"
                              type="text"
                              value={state.captcha}
                              name="captcha"
                              variant="outlined"
                              fullWidth
                              onChange={handleFormTextChange('captcha')}
                              InputLabelProps={{
                                classes: { root: classes.textField }
                              }}
                              inputProps={{
                                className: classes.inputStyle
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  handleFormSubmit(e);
                                }
                              }}  
                            />
                            {captchaErr && <p className={classes.error}>Please enter correct Captcha.</p>}
                          </Grid>
                        </Grid>
                      </div>
                    </Box>
                               
                  </Grid>
              
                  <Grid item xs={12} sm={12}>
                    <Typography className={classes.errorMsg} dangerouslySetInnerHTML={{ __html: errorMsg !== '' ? errorMsg : '' }} />
                    <Box className={`${classes.buttonContainer}`} display="flex" justifyContent="center" style={{ paddingBottom: '34px', paddingTop: '20px' }}>
                      <Button className={`${classes.resetButton}`} mt={2}
                        variant="outlined"
                        onClick={() => handleGoBack()}>
                        Cancel
                      </Button>
                      <Button className={`${classes.addAccButton}`} mt={2}
                        type="submit"
                        variant="contained"
                        color='primary'
                        disabled={loading || disableBtn || isAdminCheck()}
                        >
                        {!loading ? 'Continue' : <CircularProgress color='primary' style={{ width: 25, height: 25 }} />}
                      </Button>
                    </Box>
                  </Grid>

                </Grid>
              </form> : <>
              <Box>
                <Typography className={classes.errorMsg}>{errorMessage !== '' ? errorMessage : ''}</Typography>
                <Typography className={classes.welcome}>{getLoanLabel()} Number: {maskAccountNo(decrypt(borrowerInfo.accountNumber))}</Typography>
      
                <Grid container style={{paddingTop: '8px'}}>
                  <Grid item xs={12} sm={12} md={2}> 
                    <Typography className={classes.account}>{getBorrowerLabel()} Name:</Typography>
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={3}>               
                    <Typography className={classes.loanNo}>{borrowerInfo.pBorrowerName}</Typography>
                  </Grid>
                  
                  <Grid item xs={12} sm={12} md={2}> 
                    <Typography className={classes.account}>Email Address:</Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4}> 
                    <Box className={classes.emailBox}>
                      <Typography className={classes.loanNo}>{borrowerInfo.emailID ? maskEmail(decrypt(borrowerInfo.emailID)) : "Not Available"}</Typography>
                    </Box> 
                  </Grid>
                </Grid>

                 <Grid container>
                  <Grid item xs={12} sm={12} md={5}> 
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={7}> 
                    <Box className={classes.imageContainer}>
                      <InfoIcon className={classes.icon} />
                      <Typography><span className={classes.note}>Note:</span> <span className={classes.cancellation}>If you need to update your email address, please contact our Customer Care team.</span></Typography>
                    </Box>
                  </Grid>
                </Grid>
                 
                <Grid container>
                  <Grid item xs={12} sm={12} md={2}>               
                    <Typography className={classes.account}>Mailing Address:</Typography>
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={4}>               
                    <Typography className={classes.loanNo}>{maskMailingAddress(decrypt(borrowerInfo?.malingAddress))}</Typography>
                  </Grid>
                </Grid> 
                    
              </Box>

              <Box className={classes.line}></Box> 

             {data && <Box className="ccpa">
              {toogleStatus ? <div dangerouslySetInnerHTML={{ __html: data }}/>  :
                <div dangerouslySetInnerHTML={{ __html:  `${data?.substring(0, 260)}...` }}></div> }
                <span onClick={() => {setToogleStatus(!toogleStatus); scrollTop()}} className={classes.view}>{toogleStatus ? 'View Less' : 'View More'}</span>
              </Box> }
   <Typography className={classes.statement} style={{marginTop: '20px'}}><b>By submitting the form below, you are exercising rights available only to California residents under the CCPA.</b></Typography>

              <Typography className={classes.statement}>(Certain uses of sensitive personal information are necessary and cannot be limited.)</Typography>
              <Typography className={classes.info}>Please select one or more of the options below:</Typography>

              <Box>
                <Box className={classes.marginFixed}>
          
                      <FormGroup column className={classes.propertyRadio}>
                        <h3 className={classes.subTitle}>Opt Out Request</h3>
                        <FormControlLabel
                          control={<Checkbox
                            style={{paddingBottom: "44px"}}
                            checked={options.option1 ? true : false}
                            onChange={(event) => checkboxChangePostDataHandler(event)}
                            name="option1"
                            value="option1" />}
                            label={`I request to opt out of the sale or sharing of my personal information, including for cross-context behavioral advertising, as permitted under the California Consumer Privacy Act (CCPA). I understand that certain personal information collected in connection with financial products or services may be exempt under federal law.`}
                            classes={{
                              label: options.option1 && options.option1 === 'option1' ? classes.activeRadioLabel : classes.radioLabel
                            }}                           
                        />
                         <h3 className={classes.subTitle}>Deletion Request</h3>
                        <FormControlLabel
                          control={<Checkbox
                          style={{paddingBottom: "24px"}}
                            checked={options.option2 ? true : false}
                            onChange={(event) => checkboxChangePostDataHandler(event)}
                            name="option2"
                            value="option2" />}
                            label={`I request that ${privateLabelName} delete my personal information, to the extent permitted by law, where such information is no longer necessary for ${privateLabelName} business relationship with me or for legal and regulatory compliance.`}
                            classes={{
                              label: options.option2 && options.option2 === 'option2' ? classes.activeRadioLabel : classes.radioLabel
                            }}
                        />
                        <h3 className={classes.subTitle}>Data Correction Request</h3>
                        <FormControlLabel
                          control={<Checkbox
                            checked={options.option3 ? true : false}
                            onChange={(event) => checkboxChangePostDataHandler(event)}
                            name="option3"
                            value="option3" />}
                          label={`I request that ${privateLabelName} correct inaccurate personal information related to my account, as described below:`}
                          classes={{
                            label: options.option3 && options.option3 === 'option3' ? classes.activeRadioLabel : classes.radioLabel
                          }}
                        />
                        
                        {options.option3 &&
                         <Box className={classes.textareaSection}>
                          
                            <TextareaAutosize
                              style={{ height: '96px' }}
                              color="primary"
                              variant="outlined"
                              type="text"
                              placeholder='Please describe the information you believe is inaccurate and how it should be corrected.'
                              name="option3Desc"
                              maxLength="1000"
                              onChange={(event) => handleDesc(event)}
                              value={options.option3Desc}
                              InputLabelProps={{
                                FormLabelClasses: {
                                  asterisk: classes.labelAsterisk
                                }
                              }}
                              className={classes.textArea}
                            >
                            </TextareaAutosize>
                            <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/1000</Typography>
                            {errors.decsMandatory && <Typography className={classes.errorMsg}>Please describe the information in description box.</Typography>}

                          </Box> }

                         <h3 className={classes.subTitle}>Request to Know / Access</h3>
                        <FormControlLabel
                          control={<Checkbox
                          style={{paddingBottom: "32px"}}
                            checked={options.option4 ? true : false}
                            onChange={(event) => checkboxChangePostDataHandler(event)}
                            name="option4"
                            value="option4" />}
                          label={`I request to know what personal information ${privateLabelName} has collected about me, including the categories of information, the purposes for collection, and the categories of third parties with whom it has been disclosed, as permitted by law.`}
                          classes={{
                            label: options.option4 && options.option4 === 'option4' ? classes.activeRadioLabel : classes.radioLabel
                          }}
                        />

                         <h3 className={classes.subTitle} style={{marginTop: '4px'}}>Limit Use of Sensitive Personal Information</h3>
                         <FormControlLabel
                          control={<Checkbox
                          style={{paddingBottom: "24px"}}
                            checked={options.option5 ? true : false}
                            onChange={(event) => checkboxChangePostDataHandler(event)}
                            name="option5"
                            value="option5" />}
                          label={`I request that ${privateLabelName} limit the use and disclosure of my sensitive personal information to purposes permitted by applicable law.`}
                          classes={{
                            label: options.option5 && options.option5 === 'option5' ? classes.activeRadioLabel : classes.radioLabel
                          }}
                        />
                      </FormGroup>
                     {errors.mandatoryOptions && <Typography className={classes.errorMsg}>Please select at least one of the option from above.</Typography>}

                  </Box>
                 
                  <Grid container mt={4}>
                     <Grid item xs={12} sm={12}>
                      <p className={classes.errorMsg}>{errorMsg !== '' ? errorMsg : ''}</p>
                      <Box className={classes.buttonContainer} display="flex" justifyContent="center" style={{ paddingBottom: '30px', paddingTop: '30px' }}>
                        <Button className={classes.resetButton} mt={2}
                          variant="outlined"
                          onClick={() => handleCancel()}>
                          Cancel
                        </Button>                   

                        <Button className={classes.addAccButton} mt={2}
                          type="submit"
                          variant="contained"
                          color='primary'
                          disabled={submitLoader || isAdminCheck()}
                          onClick={() => handleRequestSubmit()}
                          >
                          {!submitLoader ? 'Submit' : <CircularProgress color='primary' style={{ width: 25, height: 25 }} />}
                        </Button>
                      </Box>
                  </Grid>
                  </Grid>
              </Box>
              </> }
          </Box>
        </Box>
          
        <RequestSubmitPopup
          open={submitPopup}
          submitResponse={() => {}}
          handleCancelIcon={() => handleSubmitPopup()}
          screen="ccpa"
          borrowerEmail={borrowerInfo.emailID ? maskEmail(decrypt(borrowerInfo.emailID)) : ''}
        />

        <DocumentRequestPopup
          open={restrictionPopup}
          handleDocumentRequest={() => handleGotIt()}
          screen="ccpa"
        />
        
        <SubmitConfirmation
          open={submitStatus}
          handleCancelIcon={() => setSubmitConfirmation(false)}
          handleSubmit={() => handleSubmitConfirmation()}
        />
      </Box>
    </Box>
  )
})
